"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");require("core-js/modules/es.array.filter");require("core-js/modules/es.array.for-each");require("core-js/modules/es.array.index-of");require("core-js/modules/es.array.splice");require("core-js/modules/es.object.keys");require("core-js/modules/web.dom-collections.for-each");exports.__esModule = true;exports.default = void 0;var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _arr = require("./arr");
var _is = require("./is");





/**
                            * EventEmitter
                            *
                            *
                            * @class EventEmitter
                            */var
EventEmitter = /*#__PURE__*/function () {function EventEmitter() {(0, _defineProperty2.default)(this, "_listeners",



    {});}var _proto = EventEmitter.prototype;

















  /**
                                               * Подписка на события
                                               *
                                               * @param {string} eventName
                                               * @param {Listener} callback
                                               * @memberof EventEmitter
                                               */_proto.
  on = function on(eventName, callback) {
    this._listeners[eventName] = (0, _arr.castArr)(this._listeners[eventName]);
    this._listeners[eventName].push(callback);
  }


  /**
     * Вызов события
     *
     * @param {string} eventName
     * @param {AnyMap} data
     * @memberof EventEmitter
     */;_proto.
  emit = function emit(eventName, data) {
    var lisArr = this._listeners[eventName];
    if (!(0, _is.isArr)(lisArr)) return;

    lisArr.forEach(function (cb) {
      if ((0, _is.isF)(cb)) {cb(data);}
    });
  }



  /**
     * Удаляет подписку(и) на событие(я)
     * Если имеются оба параметра удаляется конкретный слушатель
     * Если только имя - удаляет все слушатели одного события
     * Вызов без аргументов удалит все подписки
     *
     * @param {?string} eventName
     * @param {?Listener} callback
     * @memberof EventEmitter
     */;_proto.
  off = function off(eventName, callback) {
    if ((0, _is.isStr)(eventName)) {
      if ((0, _is.isF)(callback)) {
        this._offOneListener(eventName, callback);
      } else {
        this._offEventListeners(eventName);
      }
    } else {
      this._offAll();
    }
  };_proto.



  _offOneListener = function _offOneListener(eventName, callback) {
    var lisArr = this._listeners[eventName];
    if (!(0, _is.isArr)(lisArr)) return;
    var cbIndInArr = lisArr.indexOf(callback);
    if (cbIndInArr === -1) return;
    lisArr[cbIndInArr] = null;
    lisArr.splice(cbIndInArr, 1);
  };_proto.


  _offEventListeners = function _offEventListeners(eventName) {
    var lisArr = this._listeners[eventName];
    if (!(0, _is.isArr)(lisArr)) return;
    for (var j = 0; j < lisArr.length; j++) {
      lisArr[j] = null;
    }
    delete this._listeners[eventName];
  };_proto.


  _offAll = function _offAll() {var _this = this;
    Object.keys(this._listeners).forEach(function (eventName) {
      _this._offEventListeners(eventName);
    });
  };_proto.



  destroy = function destroy() {
    this._offAll();
  };(0, _createClass2.default)(EventEmitter, [{ key: "listenersList", /**
                                                                       * Возвращает список всех событий, на которых имеются подписчики
                                                                       *
                                                                       * @readonly
                                                                       * @type {string[]}
                                                                       * @memberof EventEmitter
                                                                       */get: function get() {var _this2 = this;return Object.keys(this._listeners).filter(function (eventName) {var eventListeners = _this2._listeners[eventName];return (0, _is.isArr)(eventListeners) && eventListeners.length !== 0;});} }]);return EventEmitter;}();exports.default = EventEmitter;


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/EventEmitter.js
// module id = 106
// module chunks = 0